import axios from "axios"
import config from './../config.js';

const api = axios.create({
    baseURL: config.baseUrl,
    withCredentials: process.env.NODE_ENV === 'production',
})

api.interceptors.response.use(function(response) {
    try {
        if ('redirect_to' in response.data) {
            window.location.href = new URLSearchParams(window.location.search).get('next') || response.data.redirect_to
        }
    } catch (e) {

    }
    return response;
}, function(error) {
    if (error.response.status === 404 && error.config.method === 'get') {
        window.location.href = '/404'
    } else {
        return Promise.reject(error);
    }
});

export default api